<template>
    <div class="shortMessage">
        <div class="tips flx alc" v-if="infos.total_sms == 0">
            <i class="el-icon-warning" style="color: #FF2E00;"></i>
            <span style="margin: 0 10px;" v-text="`你的短信余额：${infos.total_sms} ，无法自动通知提醒，影响活动报名！`"></span>
            <span class="cursor" style="color:#ED6A0C" id="">马上充值</span>
        </div>
        <div class="kantotal flx alc jsb">
            <div class="kanleft">
                <div class="kantitle">
                    短信余额(条)
                </div>
                <div class="kannum" v-text="infos.total_sms"></div>
                <div class="kanrest flx alc">
                    <div class="kritem" v-text="`累计充值(条): ${infos.total_recharge}`"></div>
                    <div class="kritem" v-text="`累计发送(条): ${infos.total_send}`"></div>
                </div>
            </div>
            <div class="kanright">
                <el-button type="primary" @click="show=true">马上充值</el-button>
            </div>
        </div>
        <div class="acctitle flx alc jsb">
            <div class="actleft flx alc">
                <div class="shus"></div>
                <div>
                    自动通知提醒
                </div>
            </div>
            <div class="acRight flx alc" :style="info.level == 2?'visibility:hidden' : ''">
                <div class="acrtips">
                    为了不影响您活动报名、提现和管理，请及时认证
                </div>
                <el-button type="primary" @click="toConfirm">马上认证</el-button>
            </div>
        </div>

        <div class="ocos">
            <div class="oc">
                <div class="octop flx alc jsb">
                    <div>
                        报名提醒
                    </div>
                    <el-switch @change="swcheng" v-model="value" active-color="#007AFF" inactive-color="#DCDFE6">
                    </el-switch>
                </div>
                <div class="ocbottom">
                    参与者报名成功后系统自动</br>发送短信通知
                </div>
            </div>
        </div>

        <div>
            <el-tabs v-model="cur" @tab-click="handleClick">
                <el-tab-pane label="发送记录" name="1"></el-tab-pane>
                <el-tab-pane label="充值记录" name="2"></el-tab-pane>
            </el-tabs>

            <div class="flx alc jsb">
                <div class="flx alc">
                    <span style="margin-right: 20px;">时间范围:</span>
                    <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="value2" type="datetimerange"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" align="right">
                    </el-date-picker>
                </div>
                <div>
                    <el-button type="primary" @click="tosearch">搜索</el-button>
                </div>
            </div>

            <div class="tables" v-if="cur == 1">
                <div class="tableTitle alc flx">
                    <div class="tablet1">
                        短信类型
                    </div>

                    <div class="tablet2">
                        发送用户
                    </div>

                    <div class="tablet3">
                        发送条数
                    </div>

                    <div class="tablet3">
                        状态
                    </div>
                </div>
                
                <div class="tableItem" v-for="item,index in list">
                    <div class="tainnertitle" v-text="`发送时间: ${item.createtime_text}`">
                        
                    </div>
                    <div class="tainner flx">
                        <div class="tablet1 bright" v-text="item.is_type_text">
                            报名提醒
                        </div>
                        
                        <div class="tablet2 flx bright" style="flex-wrap: wrap;">
                            <span v-text="item.tel"></span>
                        <!--    <br/>
                            <span style="color: #007AFF;cursor: pointer;">查看全部</span> -->
                        </div>
                        <div class="tablet3 bright">
                            {{item.num}}条
                        </div>
                        <div class="tablet3 bright" style="font-size: 18px;color: #4CC864;">
                            发送成功
                        </div>
                    </div> 
                </div>
            </div>
            
            <div style="margin-top: 32px;" v-else>
                <div class="tableTitle alc flx">
                    <div class="tablet4">
                        短信条数
                    </div>
                    <div class="tablet4">
                        实际支付(元)
                    </div>
                    <div class="tablet4">
                        支付方式
                    </div>
                    <div class="tablet4">
                        充值状态
                    </div>
                    <div class="tablet4">
                        充值时间
                    </div>
                </div>
                <div class="inchargeContent">
                    <div class="charitem flx alc" v-for="item,index in list2">
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="`${item.num}条`"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.money"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.pay_type_text"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.recharge_status_text"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.createtime_text"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="show">
            <div class="maskcontent">
                <i @click="show = false" class="el-icon-circle-close" style="color: #fff;font-weight: normal;font-size: 28px;position:absolute;top:0;right:-50px;cursor: pointer;"></i>
                
                <div class="inchargewhite">
                    <div class="iw1" v-text="shortinfo.name"></div>
                    <div class="iw2 flx jsc">
                        <span>￥</span>
                        <span style="font-size: 32px;font-weight: bold;" v-text="shortinfo.money"></span>
                        <span style="font-size: 14px;color: #666666;margin-left: 10px;" v-text="`(${shortinfo.avg_money}元/条)`"></span>
                    </div>
                    <div class="iw3" @click="incharges">
                        立即充值
                    </div>
                </div>
                <div class="tipsss">
                    *充值即表示阅读并同意<span style="color: #1C67FA;" @click="toRule(12)">《短信服务协议》</span>
                </div>
                <div class="tipss">
                    发送短信需要进行身份认证，成为 <span style="color: #1C67FA;text-decoration: underline;">认证商家</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        userInfo,
        messageindex,
        setmessagenotice,
        messagesendrecord,
        shortincharge,
        micreord
    } from "@/api/index.js"
    export default {
        name: 'shortMessage',
        data() {
            return {
                list2:[],
                shortinfo:{},
                restnum: 0,
                num1: 1265,
                num2: 2365,
                value: false,
                show: false,
                cur: '1',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value2: ['',''],
                info:{},
                value:false,
                page:1,
                list:[],
                infos:{}
            };
        },
        created() {
            this.getmessageindex()
            this.getsendrecord()
            this.getUserinfo()
        },
        methods: {
            getUserinfo() {
                let that = this
                userInfo().then((res) => {
                    console.log("333", res)
                    if (res.code == 1) {
                        that.info = res.data
                    } else {
                        // this.$message.error(res.msg)
                    }
                })
            },
            toRule(e) {
                this.$router.push({
                    path: '/rules', // 写路由path
                    query: {
                        type: 12,
                        t: Date.now()
                    }
                })
            },
            incharges(){
                let that = this
                 let data = that.shortinfo.id
                 shortincharge(data).then((res) => {
                     if(res.code == 1){
                           that.$message.success(res.msg)
                           that.show = false
                           that.page = 1
                           that.getchargerecord()
                     }else{
                         that.$message.error(res.msg)
                     }
                 })
            },
            getsendrecord(){
                let that = this 
                let data = {}
                data.page = that.page
                data.size = 50
                data.begin_time = that.value2[0]
                data.over_time = that.value2[1]
                messagesendrecord(data).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.list = res.data.data
                    }
                })
            },
            swcheng(e){
                setmessagenotice(e == true?1:0).then((res) => {
                    if(res.code == 1){
                        this.$message.success(res.msg)
                    }else{
                        this.$message.error(res.msg)
                        this.value == 0?this.value = 1:this.value = 0
                    }
                })
            },
            getmessageindex(){
                let that = this 
                messageindex().then((res) => {
                    if(res.code == 1){
                        that.infos = res.data
                        that.value = res.data.register_status == 0?false:true
                        that.shortinfo = res.data.combo
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            toConfirm() {
                this.$emit('toConfirm', '去认证')
            },
            getchargerecord(){
                
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.begin_time = that.value2[0]
                data.over_time = that.value2[1]
                micreord(data).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.list2 = res.data.data
                    }
                })
            },
            handleClick(e) {
                let that = this 
                this.page = 1
                this.value2 = []
                this.value2.push('')
                this.value2.push('')
                console.log(e)
                if(e.index == 0){
                    that.getsendrecord()
                }else{
                    that.getchargerecord()
                }
            },
            tosearch(e) {
                this.page = 1
                if(this.cur == 1){
                    this.getsendrecord()
                }else{
                    this.getchargerecord()
                }
                
            }
        }
    }
</script>

<style scoped>
    .tipss{
        width: 310px;
        position: absolute;
        bottom: 35px;
        left: 30px;
        font-size: 14px;
        color: #666666;
    }
    .tipsss{
        width: 310px;
        position: absolute;
        bottom: 67px;
        left: 30px;
        font-size: 14px;
        color: #666666;
    }
    .iw3{
        width: 139px;
        height: 30px;
        background: #1C67FA;
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 30px;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
        margin: 0 auto;
        cursor: pointer;
    }
    .iw2{
        align-items: baseline;
        margin-top: 10px;
        margin-bottom: 15px;
    }
    .iw1{
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        text-align: center;
    }
    .inchargewhite{
        width: 310px;
        height: 151px;
        background: #FFFFFF;
        border-radius: 10px;
        position: absolute;
        top: 171px;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        padding: 20px;
    }
    .maskcontent{
        width:370px;
        height:429px;
        background: url('https://two.hrxsl.com/pcImages/shortmsgbk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top:50%;
        transform: translate(-50%,-50%);
    }
    .mask{
        /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1009 !important;
    }
    .tablet4{
        flex: 1;
        flex-shrink: 0;
        text-align: center;
    }
    .tainnertitle{
        height: 32px;
        background: #f2f2f2;
        width: 100%;
        line-height: 32px;
        box-sizing: border-box;
        padding-left: 12px;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }
    
    .tables{
        margin-top: 32px;
    }
    .tableItem{
        border: 1px solid #D9D9D9;
         border-right: none;
    }
    .charitem{
        border: 1px solid #D9D9D9;
        border-right: none;
    }
    .bright{
        border-right: 1px solid #D9D9D9;
        height: 130px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 20px;
        text-align: center !important;
        font-size: 16px;
        color: #141933;
        justify-content: center;
    }
    .tablet1{
        width: 124px;
        text-align: center;
    }
    .tablet2{
        width: 514px;
        text-align: center;
    }
    .tablet3 {
        width: 143px;
        text-align: center;
    }
    .tableTitle {
        width: 100%;
        background: #F2F2F2;
        border: 1px solid #D9D9D9;
        height: 32px;
        margin-bottom: 13px;
    }

    .ocbottom {
        font-size: 12px;
        color: #666666;
        margin-top: 12px;
    }

    .octop div {
        font-weight: 600;
        font-size: 14px;
        color: #000000;
    }

    .oc {
        width: 216px;
        height: 122px;
        background: #F8F8F8;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 20px;
    }

    .shus {
        width: 4px;
        height: 18px;
        background: #007AFF;
        margin-right: 12px;
    }

    .acctitle {
        margin-top: 38px;
    }

    .accTitles {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: left;
    }

    .accNum {
        font-weight: 600;
        font-size: 26px;
        line-height: 36px;
        text-align: left;
        margin-bottom: 10px;
    }

    .accItem {
        box-sizing: border-box;
        padding: 30px 32px;
        width: 50%;
        text-align: left;
        /* flex: 1; */
    }

    .accLeft {
        width: 451px;
        height: 165px;
        background: #F9F9F9;
        border-radius: 6px;
    }

    /* 
        .accItem {
            flex: 1;
        } */

    .acrtips {
        font-weight: 500;
        font-size: 14px;
        color: #FF0F23;
        margin-right: 25px;
    }

    .actleft {
        font-weight: 600;
        font-size: 16px;
    }

    .kritem {
        font-size: 13px;
        color: #333333;
        margin-right: 62px;
    }

    .kannum {
        font-weight: 600;
        font-size: 32px;
        color: #333333;
        margin: 12px 0;
    }

    .kantitle {
        font-size: 13px;
        color: #333333;
    }

    .kantotal {
        width: 100%;
        background: #F8F8F8;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 30px;

    }

    .shortMessage {
        box-sizing: border-box;
        padding: 30px;
        text-align: left;
    }

    .tips {
        width: 100%;
        height: 39px;
        background: #FFFBE8;
        box-sizing: border-box;
        padding: 0 20px;
        margin-bottom: 16px;
    }
</style>